import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class DeliveryTypesDAO {

    static async getList(): Promise<RpcResponse> {
        return await RpcService.makeRequest('deliveryTypes.getList');
    }
}

export default DeliveryTypesDAO;
